import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";
import { UserAppStep } from "../enums/userAppStep";

export interface UserState {
  userStage: UserAppStep;
  userCameraInfo: { deviceId: string; label: string };
  userMicrophoneInfo: { deviceId: string; label: string };
  userSpeakerInfo: { deviceId: string; label: string };
}

const initialState: UserState = {
  userStage: UserAppStep.LOGIN,
  userCameraInfo: { deviceId: "", label: "" },
  userMicrophoneInfo: { deviceId: "", label: "" },
  userSpeakerInfo: { deviceId: "", label: "" },
};

export const userSlice = createSlice({
  name: "userSetup",
  initialState,
  reducers: {
    setUserStage: (state, action: PayloadAction<UserAppStep>) => {
      state.userStage = action.payload;
    },
    setUserCameraInfo: (state, action: PayloadAction<{ deviceId: string; label: string }>) => {
      state.userCameraInfo = action.payload;
    },
    setUserSpeakerInfo: (state, action: PayloadAction<{ deviceId: string; label: string }>) => {
      state.userSpeakerInfo = action.payload;
    },
    setUserMicrophoneInfo: (state, action: PayloadAction<{ deviceId: string; label: string }>) => {
      state.userMicrophoneInfo = action.payload;
    },
    setUserClearSetup: (state) => {
      state.userCameraInfo = {deviceId: "", label: ""}
      state.userMicrophoneInfo = {deviceId: "", label: ""}
      state.userSpeakerInfo = {deviceId: "", label: ""}
    },
  },
});

export const { setUserClearSetup, setUserStage, setUserCameraInfo, setUserMicrophoneInfo, setUserSpeakerInfo } = userSlice.actions;

export const selectUserStage = (state: RootState) => state.userSlice.userStage;
export const selectUserSettings = (state: RootState) => state.userSlice;


export default userSlice.reducer;
